//ORDERLISTAGE
import React, { useCallback } from "react";
import "../ordensServicoListage/ordensServicoListage.css";
import { useState, useEffect } from "react";
import Header from "../../components/header/header";
import Pagination from "react-bootstrap/Pagination";
import { Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPlus, faPencil, faTrashCan, faSearch, faFilter, faListCheck, faFilePdf,} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import MUIButton from "@mui/material/Button";
import MUIButtonGroup from "@mui/material/ButtonGroup";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import { deleteOrdem, updateOrdem} from "../../services/api_cadastro_ordens_servico";
import { getOrdens } from "../../services/api_ordens_servico";
import getDateHour from "../../hooks/GetDateHour";
import { updateSolicitacao } from "../../services/api_cadastros_solicitacoes_servico";
import dataHoraFormatada from "../../hooks/Date/dataHoraFormatada";
import { Permissions } from "../../hooks/Permission/permission";
import Select from 'react-select'
import { gerarPDF } from "./pdf/pdfOS";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: blue[600],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const OrdensServicoListage = () => {
  const navigate = useNavigate();
  const itemsPerPageOptions = [5, 10, 20, 50];
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dados, setDados] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [selectedSituacao, setSelectedSituacao] = useState(null);

  const POLLING_INTERVAL = 30000;

  const situacaoOptions = [
    { value: 0, label: "Aberta em dia" },
    { value: 1, label: "Aberta em atraso" },
    { value: 2, label: "Fechada em dia" },
    { value: 3, label: "Fechada em atraso" },
    { value: 4, label: "Cancelada" },
  ];

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const fetchData = useCallback(async ()=> {
    try {
      const response = await getOrdens();
        if (response && response.status === 200) {
          const ordensServico = response.data.OrdensServico;
          setDados(ordensServico);
          //console.log(ordensServico)
        }
        setLoading(false);
    } catch (error) {
      console.error("Erro ao obter dados:", error);
    }
  }, [])

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => {
      fetchData();
    }, POLLING_INTERVAL);

    return () => clearInterval(interval);
  }, [fetchData]);

  const situacaoMap = {
    0: "Aberta em dia",
    1: "Aberta em atraso",
    2: "Fechada em dia",
    3: "Fechada em atraso",
    4: "Cancelada",
  };

  useEffect(() => {
    const filterData = () => {
      const filtered = dados.filter((item) => {
        const situacaoDescricao = situacaoMap[item.situacao] || "";

        const matchesSearch = searchTerm
        ? item.id.toString().includes(searchTerm.toLowerCase()) ||
          item.unidade.id.toString().includes(searchTerm.toLowerCase()) ||
          item.unidade.empresa.id.toString().includes(searchTerm.toLowerCase()) ||
          item.solicitacao.toLowerCase().includes(searchTerm.toLowerCase()) ||
          situacaoDescricao.toLowerCase().includes(searchTerm.toLowerCase())
        : true;

        const matchesSituacao = selectedSituacao && selectedSituacao.length > 0 
          ? selectedSituacao.some((option) => option.value === Number(item.situacao))
          : true;


        return matchesSearch && matchesSituacao;
      });
      setFilteredData(filtered);
      setCurrentPage(1);
    };

    filterData();
  }, [searchTerm, selectedSituacao, dados]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = (searchTerm || (selectedSituacao && selectedSituacao.length > 0))
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : dados.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(
    (searchTerm ? filteredData.length : dados.length) / itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  const handleGoToEdit = (idOrdem, idUnidade) => {
    navigate(`/ordem-servico-cadastrar/`, {
      state: { idOrdem: idOrdem, idUnidade: idUnidade },
    });
  };

  const handleDeleteModal = (id) => {
    Swal.fire({
      title: "Tem certeza de que deseja inativar o registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#808B96",
      confirmButtonText: "Inativar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await deleteOrdem(id);
          //console.log(response);
          if (response && response.data) {
            //console.log(response);
            // Corrigido: Verificar se há response e response.data
            const updatedData = dados.filter((item) => item.id !== id);
            setDados(updatedData);
            setShowModal(false);
            setLoading(false);
            return true;
          } else if (response.response.status === 422) {
            if (response.response.data.mensagem) {
              const mensagem = response.response.data.mensagem;
              return Swal.showValidationMessage(`${mensagem}`);
            } else if (response.response.data.errors) {
              const error = response.response.data.errors;
              return Swal.showValidationMessage(`Erro: ${error}`);
            }
          }
        } catch (error) {
          return Swal.showValidationMessage(`
          Erro: Houve um erro ao tentar deletar o registro, por favor tente novamente
        `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value) {
          Swal.fire({
            title: "Inativado!",
            text: "O registro foi inativado com sucesso.",
            icon: "success",
            timer: 2500,
          });
        }
      }
    });
  };

  const updateOrderListage = async () => {
    const response = await getOrdens();
    if (response.status === 200) {
      setDados(response.data.OrdensServico);
      return true;
    }

    return false;
  };

  const handleSituacao = (situacao) => {
    switch (situacao) {
      case "0":
        return "Aberta em dia";
      case "1":
        return "Aberta em atraso";
      case "2":
        return "Fechada em dia";
      case "3":
        return "Fechada em atraso";
      case "4":
        return "Cancelada";
      default:
        return "Situação desconhecida";
    }
  };

  const handleCancel = async (id, idSolicitacaoServico) => {
    Swal.fire({
      title: "Informe a justificativa do cancelamento da ordem de serviço",
      input: "textarea",
      icon: "info",
      inputAttributes: {
        autocapitalize: "on",
      },
      showCancelButton: true,
      confirmButtonText: "Enviar justificativa",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#808B96",
      confirmButtonColor: "#28A745",
      showLoaderOnConfirm: true,
      preConfirm: async (inputValue) => {
        const dataHora = getDateHour();
        if (!inputValue) {
          return Swal.showValidationMessage(
            "Por favor, insira uma justificativa."
          );
        } else if (inputValue.length < 10) {
          return Swal.showValidationMessage(
            "Insira uma justificativa com, no mínimo, 10 caracteres."
          );
        }

        try {
          const response = await updateOrdem(
            id,
            {
              situacao: "4",
              data_hora_cancelamento: dataHora,
              justificativa_cancelamento: inputValue,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
            true
          );

          if (response && response.status === 200) {
            Swal.fire({
              title: "Ordem de serviço cancelada com sucesso!",
              text: "Atualizando ordens de serviço...",
              icon: "success",
              timer: 2500,
              didOpen: async () => {
                Swal.showLoading();
                await updateOrderListage();
                Swal.close();
              },
            });
          }
        } catch (error) {
          //console.log("deu erro");
          console.log(error);
          return Swal.showValidationMessage(
            `Erro ao cancelar a ordem de serviço: ${error}`
          );
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  const handleConclude = async (
    idOrdemServico,
    idSolicitacaoServico,
    situacaoOrdem
    // servicosOrdem
  ) => {
    const dataHora = getDateHour();

    if (idSolicitacaoServico) {
      try {
        await updateSolicitacao(
          idSolicitacaoServico,
          { situacao: "2" },
          true // para evitar retorno de mensagem de sucesso da atualização da solicitação
        );
      } catch (error) {
        return Swal.fire({
          icon: "error",
          title:
            "Erro ao atualizar o status da solicitação vinculada a ordem de serviço. Tente novamente.",
        });
      }
    }

    const response = await updateOrdem(
      idOrdemServico,
      {
        situacao: situacaoOrdem === "0" ? "2" : "3", // Se estava aberta em dia, passa para fechada em dia, senão, passa para fechada em atraso
        data_hora_fechamento: dataHora,
        id_user_fechou: localStorage.getItem("userId"),
      },
      true
    );

    if (response && response.status === 200) {
      const result = await Swal.fire({
        title: "Ordem de serviço concluída com sucesso!",
        text: idSolicitacaoServico
          ? "A solicitação de serviço vinculada a esta ordem teve seu status atualizado. Atualizando ordens de serviço..."
          : "Atualizando ordens de serviço...",
        icon: "success",
        showConfirmButton: false,
        didOpen: async () => {
          Swal.showLoading();
          await updateOrderListage();
          Swal.close();
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });

      if (!result.isDismissed) {
        Swal.close();
      }
    }
  };

  const renderPaginationItems = () => {
    const paginationItems = [];

    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    paginationItems.push(
      <Pagination.Item
        key={1}
        active={1 === currentPage}
        onClick={() => handlePageChange(1)}
      >
        {1}
      </Pagination.Item>
    );

    if (currentPage > 3) {
      paginationItems.push(
        <Pagination.Ellipsis key="ellipsis-start" disabled />
      );
    }

    for (
      let i = Math.max(2, currentPage - 2);
      i <= Math.min(totalPages - 1, currentPage + 2);
      i++
    ) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages - 2) {
      paginationItems.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    if (totalPages > 1) {
      paginationItems.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return paginationItems;
  };

  function ExpansibleRow(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow
          className="table-row"
          sx={{ "& > *": { borderBottom: "unset" } }}
        >
          <TableCell />
          <TableCell component="th" scope="row" sx={{ width: "20px" }}>{row.unidade.empresa.id}</TableCell>
          <TableCell component="th" scope="row" sx={{ width: "20px" }}>{row.unidade.id}</TableCell>
          <TableCell component="th" scope="row" sx={{ width: "20px" }}>{row.id}</TableCell>
          <TableCell component="th" scope="row">{row.solicitacao}</TableCell>
          <TableCell>{handleSituacao(row.situacao)}</TableCell>
          <TableCell style={{ justifyContent: "flex-end", borderBottom: "none" }} align="left" className="d-flex">
            <Permissions requiredPermissions={[{ entidade: "ServicosOrdem", actions: ["view"] }]}>
              <button
                className="btn btn-white text-dark"
                disabled={
                  row.situacao === "2" ||
                  row.situacao === "3" ||
                  row.situacao === "4" ||
                  row.deleted_at != null
                    ? true
                    : false
                }
              >
                <Link state={{ idOrdem: row.id }} to={"/execucao/"}>
                  <FontAwesomeIcon
                    icon={faListCheck}
                    size="1x"
                    color={
                      row.situacao === "2" ||
                      row.situacao === "3" ||
                      row.situacao === "4" ||
                      row.deleted_at != null
                        ? "gray"
                        : "#1E90FF"
                    }
                  />
                </Link>
              </button>
            </Permissions>
            <Permissions requiredPermissions={[{ entidade: "OrdensServico", actions: ["view"] }]}>
              <button className="btn btn-white text-dark" onClick={() => gerarPDF(row)}>
                <FontAwesomeIcon icon={faFilePdf} size="1x" color="#5374C2" />
              </button>
            </Permissions>
            <Permissions
              requiredPermissions={[
                { entidade: "OrdensServico", actions: ["update"] },
              ]}
            >
              <button
                className="btn btn-white text-dark"
                onClick={() => handleGoToEdit(row.id, row.id_unidade)}
                disabled={
                  row.situacao === "2" ||
                  row.situacao === "3" ||
                  row.situacao === "4" ||
                  row.deleted_at != null
                    ? true
                    : false
                }
              >
                <Link>
                  <FontAwesomeIcon
                    icon={faPencil}
                    size="1x"
                    color={
                      row.situacao === "2" ||
                      row.situacao === "3" ||
                      row.situacao === "4" ||
                      row.deleted_at != null
                        ? "gray"
                        : "#1E90FF"
                    }
                  />
                </Link>
              </button>
            </Permissions>
            <Permissions
              requiredPermissions={[
                { entidade: "OrdensServico", actions: ["delete"] },
              ]}
            >
              <button
                className="btn btn-white text-dark"
                onClick={() => handleDeleteModal(row.id)}
                disabled={
                  row.id_solicitacao_servico != null ||
                  row.id_plano_manutencao != null ||
                  row.deleted_at
                    ? true
                    : false
                }
              >
                <FontAwesomeIcon
                  icon={faTrashCan}
                  size="1x"
                  color={
                    row.id_solicitacao_servico != null ||
                    row.id_plano_manutencao != null ||
                    row.deleted_at
                      ? "gray"
                      : "#F08080"
                  }
                />
              </button>
            </Permissions>

            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <p>
                  <strong>ID: </strong> {row.id}
                </p>
                <p>
                  <strong>Gerada por: </strong>{" "}
                  {`${row.id_user_gerou} - ${row.user_gerou?.name}`}
                </p>
                <p>
                  <strong>Solicitação: </strong> {row.solicitacao}
                </p>
                <p>
                  <strong>Aplicação: </strong>{" "}
                  {`${row.id_aplicacao ?? ""} - ${
                    row.aplicacao?.descricao ?? "Aplicação Indisponível"
                  }`}
                </p>
                <p>
                  <strong>Empresa: </strong>{" "}
                  {`${row.unidade?.empresa?.id ?? ""} - ${
                    row.unidade?.empresa?.nome ?? "Empresa Indisponível"
                  } `}
                </p>
                <p>
                  <strong>Unidade: </strong>{" "}
                  {`${row.id_unidade ?? ""} - ${
                    row.unidade?.nome ?? "Unidade Indisponível"
                  }`}
                </p>
                <p>
                  <strong>Tipo de manutenção: </strong>{" "}
                  {`${row.id_tipo_manutencao ?? ""} - ${
                    row.tipo_manutencao?.descricao ??
                    "Tipo de Manutenção Inativado"
                  }`}
                </p>
                <p>
                  <strong>Previsão de início: </strong>
                  {dataHoraFormatada(row.previsao_inicio)}
                </p>
                <p>
                  <strong>Previsão de término: </strong>
                  {dataHoraFormatada(row.previsao_termino)}
                </p>
                <p>
                  <strong>Situação: </strong>
                  {handleSituacao(row.situacao)}
                </p>
                {row.data_hora_fechamento ? (
                  <p>
                    <strong>Fechada em: </strong>
                    {dataHoraFormatada(row.data_hora_fechamento)}
                  </p>
                ) : null}
                {row.id_user_fechou ? (
                  <p>
                    <strong>Fechada por: </strong>{" "}
                    {`${row.id_user_fechou} - ${row.user_fechou?.name}`}
                  </p>
                ) : null}
                {row.data_hora_cancelamento ? (
                  <p>
                    <strong>Cancelada em: </strong>
                    {dataHoraFormatada(row.data_hora_cancelamento)}
                  </p>
                ) : null}
                {row.id_user_cancelou ? (
                  <p>
                    <strong>Cancelada por: </strong>{" "}
                    {`${row.id_user_cancelou} - ${row.user_cancelou?.name}`}
                  </p>
                ) : null}
                {row.justificativa_cancelamento ? (
                  <p>
                    <strong>Justificativa do cancelamento: </strong>{" "}
                    {row.justificativa_cancelamento}
                  </p>
                ) : null}
                {row.id_solicitacao_servico ? (
                  <p>
                    <strong>Solicitação de serviço: </strong>
                    {`${row.id_solicitacao_servico} - ${row.solicitacao_servico.solicitacao}`}
                  </p>
                ) : null}
                {row.id_plano_manutencao ? (
                  <p>
                    <strong>Plano de manutenção: </strong>
                    {`${row.id_plano_manutencao} - ${row.plano_manutencao.descricao}`}
                  </p>
                ) : null}
                {row.anexo ? (
                  <>
                    <p>
                      <strong>Anexo:</strong>
                    </p>
                    <p>
                      <img width="250px" src={row.anexo} alt="" />
                    </p>
                  </>
                ) : null}
                <MUIButtonGroup
                  variant="contained"
                  aria-label="Basic button group"
                  className="text-center shadow-none"
                >
                  {row.situacao === "0" || row.situacao === "1" ? (
                    <>
                      <MUIButton
                        color="info"
                        className="mr-2 bg-light border border-dark rounded-pill"
                        onClick={() =>
                          handleConclude(
                            row.id,
                            row.id_solicitacao_servico,
                            row.situacao,
                            row.servicos_ordem
                          )
                        }
                      >
                        {row.previsao_termino >= getDateHour()
                          ? "Fechar em dia"
                          : "Fechar em atraso"}
                      </MUIButton>
                      <MUIButton
                        color="info"
                        className="bg-light border border-dark rounded-pill"
                        onClick={() =>
                          handleCancel(
                            row.id,
                            row.id_solicitacao_servico,
                            row.servicos_ordem
                          )
                        }
                      >
                        Cancelar
                      </MUIButton>
                    </>
                  ) : null}
                </MUIButtonGroup>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <Header title="Serviços / Listagem de Ordens de Serviço" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        <div className="mt-4 mb-3">
          <div className="mt-1 mb-3 mt-3">
            <Permissions
              requiredPermissions={[
                { entidade: "OrdensServico", actions: ["store"] },
              ]}
            >
              <Link to={`/ordem-servico-cadastrar`}>
                <button className="btn btn-light text-dark">
                  <FontAwesomeIcon icon={faPlus} size="1x" color="#006400" />
                </button>
              </Link>
            </Permissions>
          </div>

          {isLoading ? (
            <></>
          ) : (
            <>
              <Row>
                <Col md={1} className="mb-3">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faFilter} size="1x" color="#000000" className="mr-2"/>

                    <Form.Control as="select" value={itemsPerPage} onChange={handleItemsPerPageChange} className="ml-2">
                      {itemsPerPageOptions.map((option) => (
                        <option key={option} value={option}> {option} </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3} className="mb-3 ml-auto">
                  <Select
                    isMulti
                    options={situacaoOptions}
                    value={selectedSituacao}
                    onChange={setSelectedSituacao}
                    isClearable
                    placeholder="Filtrar por situação"
                    styles={{
                      control: (base) => ({
                        ...base,
                        maxHeight: '100px',
                        overflowX: 'hidden',   // rolagem horizontal se necessário
                        display: 'flex',
                        flexWrap: 'nowrap',  // impede quebra de linha
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        display: 'flex',
                        flexWrap: 'nowrap',
                        overflowX: 'hidden',
                      }),
                      multiValue: (base) => ({
                        ...base,
                        marginRight: '4px',
                      }),
                    }}
                  />
                </Col>
                <Col md={3} className="mb-3 ml-auto">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faSearch} size="1x" color="#000000" className="mr-2" />

                    <Form.Control type="text" placeholder="Digite para pesquisar" onChange={(e) => setSearchTerm(e.target.value)} className="ml-2"/>
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </div>

        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell />
                    <StyledTableCell>Cód. Empresa</StyledTableCell>
                    <StyledTableCell>Cód. Unidade</StyledTableCell>
                    <StyledTableCell>ID</StyledTableCell>
                    <StyledTableCell>Solicitação</StyledTableCell>
                    <StyledTableCell>Situação</StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItems.map((item) => (
                    <ExpansibleRow key={item.id} row={item} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Pagination className="mt-4">{renderPaginationItems()}</Pagination>
          </>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
        isQuestion={modalContent.isQuestion}
        questionAction={modalContent.qFunc}
      />
    </>
  );
};

export default OrdensServicoListage;
